import React from "react";
import { createStackNavigator } from "@react-navigation/stack";

const Stack = createStackNavigator();

function StackNavigator({ screens = [] }) {
  return (
    <Stack.Navigator screenOptions={{ cardStyle: { flex: 1 } }}>
      {screens.map(({ name, component, options = {} }, index) => (
        <Stack.Screen
          key={index}
          name={name}
          component={component}
          options={{ headerShown: false, ...options }}
        />
      ))}
    </Stack.Navigator>
  );
}

export default StackNavigator;
